import React, { Component } from 'react';
import {withRouter} from 'react-router-dom';
import { withStyles } from '@material-ui/core/styles';
import {withContext} from '../../custom/StateProvider';
import {
    API,
    BASE_URL,
    BROKER_EMAIL, BROKER_EMAIL_LOGO,
    BROKER_EMAIL_MASTHEAD,
    BROKER_NAME,
    EMAIL_API,
    EMAIL_METHOD
} from "../../../config";

import Utils from "../../custom/utils";
import NewInvestorButton from "./components/newInvestorButton";
import {connect} from "react-redux";
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import {Button} from "@material-ui/core";

const axios = require('axios');
const db_utils = API.service('investors');

const styles = theme => ({
    heading1:{
        color:theme.colorPrimary
    },
    header:{
        backgroundColor:"#262933",
        padding:'18px',
        paddingTop:'17px',
        color:'white'
    },
    flex: {
      flex: 1,
    },
});

class MailOut extends Component {
    state = {
        investors: false,
        success:0,
    }

    fetchData = () => {
        const app = this;

        let query = {query:{_surname:'Phillips'}}

        db_utils.find().then(inv =>{
          console.log('hmmm',inv, query)
            app.setState({
              investors:inv.data
            })
            console.log(this.props);
        }).catch(e=>{
            console.log('Error Loading:', e);
            app.setState({
                error:'Error: ' + e
            })
        })
    }

    investorState(state) {
        let InvStatus = Utils.returnState(state);
        return(
          <div className={'kyc-label ' + InvStatus[0]}>{InvStatus[1]}</div>
        )
    }

    componentDidMount = () => {
        this.fetchData();
        console.log('investors',this.state.investors);
    }

    sendEmail = () => {
        const app = this;
        console.log('send',app.state.investors);
        app.state.investors.forEach((investor) => {

            if(EMAIL_METHOD !== 'legacy'){
                axios.post(EMAIL_API + '/requests', {
                    sender: 'Investor Portal',
                    payload: {
                        transportName: 'sendgrid',
                        to: investor._email,
                        from: BROKER_EMAIL,
                        subject: 'Account Maintenance Fees',
                        templateName: 'account_maintenance',
                        data: {
                            broker_email: BROKER_EMAIL,
                            broker_name: BROKER_NAME,
                            base_url: BASE_URL,
                            email_masthead: BROKER_EMAIL_MASTHEAD,
                            email_logo: BROKER_EMAIL_LOGO,
                            clientName: investor._firstname + " " + investor._surname,
                            accountNumber: investor._account,
                            language: this.state.lang,
                        }
                    }
                }).then(function (data) {
                    console.log('Email Sent');
                    app.setState({
                        success: app.state.success + 1
                    })
                })
            }
        })
    }

    render() {

        const {classes} = this.props;

        return (
            <React.Fragment>

                      <AppBar position="static" elevation={0} style={{boxShadow:'none'}}>
                        <Toolbar>
                          <Typography variant="title" color="inherit" className={classes.flex}>
                            Investors
                          </Typography>
                            {(this.props.user.role.includes('super') || this.props.user.role.includes('investor_creation')) &&
                              <NewInvestorButton />
                            }
                        </Toolbar>
                      </AppBar>

                  {(this.state.investors !== false) &&
                    <div className={'p-24'}>
                        <div>Investors Selected: {this.state.investors.length}</div>
                        <div>Email to Send: Account Maintenance Fees</div>
                        <div><Button onClick={this.sendEmail}>Send Email</Button></div>
                        <div>Emails Sent: {this.state.success}</div>
                    </div>
                    }
            </React.Fragment>
        );
    }
}

function mapStateToProps({ fuse, auth }) {
  return {
    user: auth.user
  }
}

export default withContext(withStyles(styles,{withTheme:true})(withRouter(connect(mapStateToProps)(MailOut))));
